'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { styled } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
import Box from '@classify/react-core-components/Box';
import Stack from '@classify/react-core-components/Stack';
import Card from '@classify/react-core-components/Card';
import { translate } from '@openclassrooms/translations';
import CourseProgress from './CourseProgress';
import LearningOutcome from './LearningOutcome';
import CourseFinishedSvg from '../../images/course-finished.svg';
type Props = {
  progression?: number;
  learningOutcomes?: {
    status: string;
  }[];
};
const StartBlock = styled(Box)(({
  theme
}) => ({
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 3)
  }
}));
const EndBlock = styled(Box)(({
  theme
}) => ({
  borderTop: `1px solid ${theme.palette.stroke}`,
  padding: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 3),
    borderLeft: `1px solid ${theme.palette.stroke}`,
    borderTop: 'unset'
  }
}));
export default function CourseFinishedCard(t0) {
  const $ = _c(19);
  const {
    progression: t1,
    learningOutcomes: t2
  } = t0;
  const progression = t1 === undefined ? 100 : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const learningOutcomes = t3;
  let t4;
  if ($[2] !== learningOutcomes) {
    t4 = learningOutcomes.filter(_temp);
    $[2] = learningOutcomes;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const passedOutcomes = t4;
  const shouldShowLearningOutcomes = learningOutcomes.length > 0;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      width: {
        xs: 1,
        sm: "auto"
      },
      minWidth: 288
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Box sx={{
      textAlign: "center",
      mb: -5
    }}><Image src={CourseFinishedSvg} alt="" width={180} height={180} /></Box>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      pt: 6,
      pb: 4,
      px: 2
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Typography variant="h3" component="h2" sx={{
      textAlign: "center",
      color: "success.main"
    }}>{translate("course.completed.congrats.title")}</Typography>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t10;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      xs: "column",
      sm: "row"
    };
    t10 = {
      mt: {
        sm: 2
      }
    };
    $[8] = t10;
    $[9] = t9;
  } else {
    t10 = $[8];
    t9 = $[9];
  }
  let t11;
  if ($[10] !== progression) {
    t11 = <StartBlock><CourseProgress progression={progression} /></StartBlock>;
    $[10] = progression;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== learningOutcomes.length || $[13] !== passedOutcomes || $[14] !== shouldShowLearningOutcomes) {
    t12 = shouldShowLearningOutcomes && <EndBlock><LearningOutcome value={passedOutcomes.length} max={learningOutcomes?.length || 100} /></EndBlock>;
    $[12] = learningOutcomes.length;
    $[13] = passedOutcomes;
    $[14] = shouldShowLearningOutcomes;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t11 || $[17] !== t12) {
    t13 = <Box sx={t5} data-testid="course-finished-card">{t6}<Card sx={t7}>{t8}<Stack direction={t9} sx={t10}>{t11}{t12}</Stack></Card></Box>;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  return t13;
}
function _temp(outcome) {
  return outcome.status === "passed";
}